module.exports = __webpack_public_path__ + "media/student_finance/student_finance_blue_belle-7af7cbfe.jpg";